<template>
	<el-card class="guest-container" v-loading="loading">
		<template #header>
		  <div class="header">
			  <el-button type="primary" size="small" icon="el-icon-plus" @click="editManager('')">新增</el-button>
			  <el-button type="warning" size="small" icon="el-icon-plus" @click="updateManagerSort()">更新排序</el-button>
		  </div>
		</template>
		<el-table
		
		:data="list"
		tooltip-effect="dark"
		style="width: 100%"
		>
			<el-table-column label="排序" prop="sort_order">
				<template v-slot="scope">
				    <el-input :style="{'width':'40%'}" type="text" v-model="scope.row.sort_order"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="日志标题" prop="title">
			</el-table-column>
			<el-table-column label="开始时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.start_time)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.end_time)}}
				</template>
			</el-table-column>
			<el-table-column
			  label="是否放置首页"
			>
			  <template #default="scope">
					<el-switch
						v-model="scope.row.status"
						active-color="#409EFF"
						inactive-color="#F56C6C"
						:active-value="1"
						:inactive-value="2"
						@change="changeEnabled(scope.row.status, scope.row.id)">
					</el-switch>
			  </template>
			</el-table-column>
			<el-table-column
			  label="操作"
			  width="auto"
			>
			  <template #default="scope">
						  <el-button type="primary" size="mini" @click="editManager(scope.row)">编辑</el-button>
						  <el-button type="warning" size="mini" @click="delManager(scope.row)">删除</el-button>
			  </template>
			</el-table-column>
		</el-table>
	</el-card>	
	<el-dialog title="编辑" v-model="dialogFormVisible">
		<div class="col">
			<el-form  label-position="right" label-width="100px" :model="form" ref="form" :rules="rules">
				<el-form-item label="日志标题" prop="title" >
					<el-input v-model="form.title" size="small" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="日志内容" prop="manager_content">
					<ueditor ref='ue' v-model="form.manager_content" :config="myconfig_ueditor"></ueditor>
				</el-form-item>
				<el-form-item label="开始时间" prop="start_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.start_time" type="date" placeholder="选择开始时间" autocomplete="off"></el-input>
					 </div>
				</el-form-item>
				<el-form-item label="结束时间" prop="end_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.end_time" type="date" placeholder="选择结束时间" autocomplete="off"></el-input>
					  </div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import Ueditor from '../common/Ueditor.vue'
	export default{
		name: 'StoreManagerLog',
		components:{
			Ueditor,
		},
		data(){
			return{
				myconfig_ueditor: {
					UEDITOR_HOME_URL: '/UEditor/',
					serverUrl: this.getEnv('host') + '/admin/ueditor/ueditor',
					autoHeightEnabled: false,
					initialFrameHeight: 400,
					initialFrameWidth: '100%',
					zIndex:999999,
					toolbars: [
						['source', '|', 'undo', 'redo', '|', 'bold', 'italic',
							'underline', 'strikethrough', '|', 'superscript', 'subscript', '|',
							'forecolor', 'backcolor', '|', 'removeformat', '|',
							'insertorderedlist', 'insertunorderedlist', '|', 'selectall',
							'cleardoc', 'paragraph', '|', 'fontfamily', 'fontsize',
							'|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify',
							'|', 'link', 'unlink', '|', 'emotion', 'simpleupload', 'insertimage',
							'video', '|', 'map', '|', 'horizontal', 'print', 'preview',
							'fullscreen', 'drafts', 'formula'
						]
					] //需要展示的按钮
				},
				loading:true,
				list:[],
				dialogFormVisible:false,
				thumbList:[],
				sort_orders_string:[],
				form:{
					title:'',
					manager_content:'',
					start_time:'',
					end_time:'',
					sort_order:0,
					
				},
				rules: {
					title: [{
						required: true,
						message: '请填写名称',
						trigger: 'blur'
					}],
					manager_content: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}],
					start_time:[{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time:[{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				},
			}
		},
		
		methods:{
			getManager(){
				this.httpPost({
					url:'/admin/homeSetting/manager_log_list',
					data: {
						routePath: this.$route.path
					}
				}).then((res)=>{
					// console.log(res);
					this.list=res.data;
					this.loading=false;
				console.log(this.list);
				})
			},
			changeEnabled(status, id){
				let select_id = id;
				let change_status = status;
				if(select_id){
					this.loading=true;
					this.httpPost({
						url:'/admin/homeSetting/change_manager_status',
						data:{id:select_id,status:change_status}
					}).then((res)=>{
						if(res.code ==1){
							this.$message.success(res.msg);
							this.loading =false;
						}
					})
				}
			},
			editManager(val){
				this.dialogFormVisible=true;
				let temp = this.cloneObj(val);
				console.log(this.$refs.ue)
				if (val) {
					temp.start_time = this.timestampToTime(temp.start_time);
					temp.end_time = this.timestampToTime(temp.end_time);
					this.form = temp;
					this.$nextTick(() => {
						this.$refs.ue.setText(temp.manager_content); //回显 富文本内容
					})
				} else {
					this.resetObj(this.form);
					this.$nextTick(() => {
						this.$refs.ue.setText('',false); //回显 富文本内容
					})
				}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			delManager(val){
				let id = val.id;
				this.msgBoxAjax(
				  '提示',
				  '确定删除吗？',
				  "/admin/homeSetting/delManager",
				  {id:id}).then((res) => {
				  // console.log(data);
							
				  if (res.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							
				      this.getManager();
				    });
				  }else{
							
				    this.messageCommon('错误',res.msg,'error');
				  }		
				});
			},
			updateManagerSort(){
				let ids = [];
				this.sort_orders_string =[];
				this.$confirm('此操作将更新排序, 是否继续?', '提示', {
				                        confirmButtonText: '确定',
				                        cancelButtonText: '取消',
				                        type: 'warning'
				                    }).then((re) => {
				                        for (let i in this.list){
				                            if (this.sort_orders_string.indexOf(this.list[i].sort_order) == '-1'){
				                                //==-1表示该字符串不在此数组,返回值为-1
				                                this.sort_orders_string.push(this.list[i].sort_order);
				                                ids.push({id:this.list[i].id,sort_order:this.list[i].sort_order});
				                            }else{
				                                this.$message.error('排序有重复值');
				                                this.sort_orders_string = [];
				                                return;
				                            }
				                        }
										// console.log(ids);return;
										this.httpPost({
											url:'/admin/homeSetting/updateManagerSort',
											data:ids
										}).then((res)=>{
											if(res.code ==1){
												this.$message.success(res.msg);
												this.getManager();
											}
										})
				                    })
			},
			submit(){
				this.form.manager_content = this.$refs.ue.getUEContent();				
				this.$refs['form'].validate((valid)=>{
					if(valid){
						this.updateManager();
					}else{
						console.log('error submit!')
						return false;
					}
				})
				
			},
			updateManager(){
				this.loading = true;
				let id = this.form.id;
				if (!id) id = '';
				this.httpPost({
					url:'/admin/homeSetting/modify_manager_log?id='+ id,
					data:this.form
				}).then((res)=>{
					if(res.code ==1){
						this.dialogFormVisible = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getManager();
					}
				})
			}
		},
		created() {
			this.getManager();
		}
	}
</script>

<style>
</style>
